import { render, staticRenderFns } from "./Modal-listado.vue?vue&type=template&id=65621d21&scoped=true&lang=pug"
import script from "./Modal-listado.vue?vue&type=script&lang=js"
export * from "./Modal-listado.vue?vue&type=script&lang=js"
import style0 from "./Modal-listado.vue?vue&type=style&index=0&id=65621d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65621d21",
  null
  
)

export default component.exports